export default __webpack_public_path__ + "static/media/c5.2907a582.jpg";